import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import {
  FLEX_BALANCE_RESOURCE_API_URL,
  getFlexBalanceResourceValues,
} from '@/features/flexBalance/endpoints/flexbalance'
import type { FlexBalanceResource, FlexBalanceResourcePage } from '@/features/flexBalance/types'
import type { UseQueryOptions } from '@/types/queries'

export type UseFlexBalanceResourceQueryResult = Omit<UseQueryResult, 'data'> & {
  flexBalanceResources: FlexBalanceResource[] | null
  currentPage: number
  totalCount: number
}

export function useFlexBalanceResourceQuery(
  options?: UseQueryOptions<FlexBalanceResourcePage>,
): UseFlexBalanceResourceQueryResult {
  const { data, ...queryResult } = useQuery({
    ...options,
    queryFn: getFlexBalanceResourceValues,
    queryKey: [FLEX_BALANCE_RESOURCE_API_URL],
  })

  return {
    ...queryResult,
    flexBalanceResources: data?.values ?? null,
    currentPage: data?.currentPage ?? 0,
    totalCount: data?.totalCount ?? 0,
  }
}
